<script setup lang="ts">
    const props = defineProps<{
        id: string;
    }>();

    const { data, error, status } = await useAcademyTraining(() => props.id);
    const isLoading = computed(() => status.value === 'idle' || status.value === 'pending');

    const { rawPath } = useCleanStoryblokPath();
    const { data: story } = await useStory<AcademyCourseDetailPageStoryblok>(rawPath, null, {
        disableFatalErrors: true // additional content might be missing, so we don't want to throw an error
    });
    useStoryblokBridgeRef(story);

    useHead({
        title: () =>
            data.value ? `${data.value.title} | Training | Medice Health Family` : 'Training | Medice Health Family'
    });

    watch(
        error,
        (fetchError) => {
            if (fetchError) showError({ ...fetchError, fatal: true });
        },
        { immediate: true }
    );

    const additionalContent = computed(() => story.value?.content?.additional_content ?? []);
</script>

<template>
    <div>
        <AcademyTrainingHero
            :is-loading="isLoading"
            :training="data"
        />

        <SharedPageContent>
            <AcademyTrainingContent
                :is-loading="isLoading"
                :training="data"
            />

            <div
                v-if="additionalContent?.length > 0"
                class="full-width"
            >
                <StoryblokComponentWrapper
                    v-for="blok in additionalContent"
                    :key="blok._uid"
                    :blok="blok"
                />
            </div>

            <div
                v-else
                class="full-width"
            >
                <AcademyTrainingRelatedCarousel
                    :course-id="id"
                    mode="same_catalog"
                />
            </div>
        </SharedPageContent>
    </div>
</template>
